import { Component, computed, inject, input } from '@angular/core';
import { EditEventFormStore } from '../../_services/edit-event-form-store.service';
import { FormGroup } from '@angular/forms';
import { EventForm } from '../../../_models/event-form.model';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'submit-step-edit-event',
  standalone: false,
  templateUrl: './submit-step-edit-event.component.html',
  styleUrl: './submit-step-edit-event.component.scss'
})
export class SubmitStepEditEventComponent {
  public formGroup = input.required<FormGroup<EventForm>>();

  public eventFormStore = inject(EditEventFormStore);

  public streappEvent = this.eventFormStore.streappEvent;

  public authService = inject(AuthService);

  public linkedEvent = computed(() => !!this.eventFormStore.streappEvent().linkedToMainStreappID);
}
